import credentialingTranslations from '../locales/en/credentialing.json';
import { licenseStatuses } from './extraTypes';
export const occupationEcls = [
    { value: 'ecl1', label: 'ECL 1' },
    { value: 'ecl2', label: 'ECL 2' },
    { value: 'ecl3', label: 'ECL 3' },
    { value: 'ecl4', label: 'ECL 4' },
    { value: 'noEcl', label: 'No ECL' },
];
export const licenseStatusesSelectValues = licenseStatuses.map((licenseStatusValue) => {
    return { value: licenseStatusValue, label: credentialingTranslations.licenseStatuses[licenseStatusValue] };
});
export const oigBoardName = 'Office of Inspector General LEIE Status';
export const licenseNumberMask = '********';
export const ssnMask = '***-**-****';
export const licenseCheckMessageName = 'license-check';
export const testLicenseCheckMessageName = 'test-license-check';
export const credentialingOccupationChangeMessageName = 'credentialing-occupation-change';
export const credentialingJASBoardChangeMessageName = 'credentialing-jas-board-change';
export const credentialingOccupationCredentialChangeMessageName = 'credentialing-occupation-credential-change';
export const defaultCredentialingRoutes = {
    root: 'screenings',
    backgroundChecks: 'background-checks',
    credentialVerifications: 'credentials',
};
export const MS_IN_A_DAY = 24 * 60 * 60 * 1000;
